const reason = {
  listReason: {
    title: "العنوان",
    id: "المعرف",
    noReasonDescription: "لم يتم العثور على سبب للرواتب",
    reasonTitle: "اسم السبب",
    actions: "الإجراءات",
    manageReasons: "إدارة الأسباب",
  },
  listReasonBreadcrumb: {
    reason: "قائمة الأسباب",
  },
  actions: {
    edit: "تعديل",
    editReasons: "تعديل السبب",
  },
  placeholder: "يرجى إدخال السبب",
};

export default reason;
